import { render, staticRenderFns } from "./Sav.vue?vue&type=template&id=2738bed8&"
import script from "./Sav.vue?vue&type=script&lang=ts&"
export * from "./Sav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports